import React from "react";
import styled from "@emotion/styled";
import { useStaticQuery, graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation, Trans } from "gatsby-plugin-react-i18next";
import { DesignWithUs } from "./VideoMobile/VideoConfig";
import SlideWithButton from "./Slide/SlideWithButton";
import { VideoContainer } from "./Feature/VideoFeature";
import { WrapperContainer, WrapperContainerSlider } from "./Style/index";

const WrapperVideo = styled.div`
  display: grid;
  gap: 1em;
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  order: 1;
`;

const DesignPersonal = ({ order }) => {
  const { t } = useTranslation();
  const { personUseSlide } = useStaticQuery(graphql`
    query {
      personUseSlide: allFile(
        filter: { relativeDirectory: { eq: "Mobile/PersonUse" } }
        sort: { fields: name }
      ) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                quality: 70
                width: 200
                blurredOptions: { width: 100 }
              )
            }
            base
            id
          }
        }
      }
    }
  `);

  return (
    <WrapperContainer>
      <WrapperVideo>
        <div className="card-video">
          <div className="header-card">
            <StaticImage
              placeholder="blurred"
              quality="50"
              src="../../../images/Mobile/ThumbnailCard/ThumbAstor.png"
              alt=""
              width={50}
            />

            <div>
              <h1>Personal Masterpiece</h1>
              <h2>KUU Creator</h2>
            </div>
          </div>
          <VideoContainer videoName={DesignWithUs} paddingTop="140%" />
        </div>
      </WrapperVideo>
      <WrapperContainerSlider order={order}>
        <div className="container-text">
          <h1>
            <Trans components={[<br />]}>{t("app.Design Personal")}</Trans>
          </h1>
          <p>
            <Trans components={[<br />]}>{t("app.Have fun with")}</Trans>
          </p>
        </div>
        <SlideWithButton
          image={personUseSlide}
          nextButtonName="nextPersonal"
          nextButtonPre="prePersonal"
        />
      </WrapperContainerSlider>
    </WrapperContainer>
  );
};
export default DesignPersonal;
